import React from 'react';

/**
 * RecommendedHint — a green "Recommended/Recomendado" badge + a one-line note
 * explaining WHY an input is asked. CHEKSTE is a concrete analysis tool: every
 * input it requests is real DATA that drives a real result, not an optional tweak.
 * Reuse this under any key input (after-repair rent, GRM, rehab, ...).
 *
 * Props:
 *   lang: 'en' | 'es'
 *   en:   the English why-note (without the badge word)
 *   es:   the Spanish why-note
 */
export default function RecommendedHint({ lang, en, es }) {
  return (
    <p className="text-[11px] text-emerald-700 mt-1 flex items-start gap-1.5" data-testid="recommended-hint">
      <span className="inline-block shrink-0 text-[9px] font-bold uppercase tracking-wide bg-emerald-600 text-white px-1.5 py-0.5 rounded">
        {lang === 'en' ? 'Recommended' : 'Recomendado'}
      </span>
      <span className="leading-snug">{lang === 'en' ? en : es}</span>
    </p>
  );
}
